import React from 'react'
import './Resume.css'
import Heading from '../Heading/Heading'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const Resume = () => {

    const education = [
        {
            start : 'March 2013',
            end : "Present",
            course : 'Masteral in Information Technology',
            description : "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic.",
            city : "New York University"
        },
        {
            start : 'March 2013',
            end : "Present",
            course : 'Masteral in Information Technology',
            description : "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic.",
            city : "New York University"
        },
        {
            start : 'March 2013',
            end : "Present",
            course : 'Masteral in Information Technology',
            description : "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic.",
            city : "New York University"
        },
    ]
    
    const expreince = [
        {
            start : 'March 2013',
            end : "Present",
            job : 'Masteral in Information Technology',
            description : "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic.",
            cmpName : "Google Inc"
        },
        {
            start : 'March 2013',
            end : "Present",
            job : 'Masteral in Information Technology',
            description : "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic.",
            cmpName : "Google Inc"
        },
        {
            start : 'March 2013',
            end : "Present",
            job : 'Masteral in Information Technology',
            description : "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic.",
            cmpName : "Google Inc"
        },
    ]

  return (
    <div className='resumeCon' id='resume'>
        <Heading thinText={'My'} boldText={'Resume'} />
        <div className="container">
            <div className={`${'education'} ${'section'}`}>
                <h3 className='title'>Education</h3>
                {
                    education.map((education, i) => {
                        return (
                            <>
                                <div className="sectionContainer">
                                    <div className="dateDiv">
                                        <CalendarMonthIcon className='dateIcon'/> {education.start} - {education.end}
                                    </div>
                                    <h3 className={`${'title'} ${'titleM'}`}>{education.course}</h3>
                                    <p className='description'>{education.description}</p>
                                    <span className='ftText'>{education.city}</span>
                                </div>
                            </>
                        )
                    })
                }
            </div>
            <div className={`${'expreince'} ${'section'}`}>
                <h3 className='title'>Experience</h3>
                {
                    expreince.map((expreince, i) => {
                        return (
                            <>
                                <div className="sectionContainer">
                                    <div className="dateDiv">
                                        <CalendarMonthIcon className='dateIcon'/> {expreince.start} - {expreince.end}
                                    </div>
                                    <h3 className={`${'title'} ${'titleM'}`}>{expreince.job}</h3>
                                    <p className='description'>{expreince.description}</p>
                                    <span className='ftText'>{expreince.cmpName}</span>
                                </div>
                            </>
                        )
                    })
                }
            </div>
        </div>
    </div>
  )
}

export default Resume